import React, { useContext } from "react";
import { api } from "../../../utils";
import { FormContext } from "../../../utils/stateHandlers/contexts";
import formatting from "../../../utils/formatHelpers";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import ClearIcon from "@mui/icons-material/Clear";
import _ from "lodash";
import { Mobile, Default } from "../../../utils/deviceHelpers";

export default function RefiningEstimatorPreview(props) {
  const { formState, dispatch } = useContext(FormContext);
  const { estimates, quoteId } = formState;

  function removeEstimate(id) {
    api
      .post("forms/refining/remove", { quote_id: quoteId, id: id })
      .then((res) => {
        const remainingEstimates = _.filter(estimates, function (estimate) {
          return estimate.id !== id;
        });
        dispatch({
          type: "submitRefiningEstimate",
          payload: {
            estimates: remainingEstimates,
            quoteId: quoteId,
          },
        });
      });
  }

  return (
    <>
      <Typography variant="h6" align="center">
        Your Estimates
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <Mobile>
              <TableCell>Metal (Wt)</TableCell>
            </Mobile>
            <Default>
              <TableCell>Weight</TableCell>
              <TableCell>Metal</TableCell>
            </Default>
            <TableCell>We'll Pay</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {estimates.map((estimate) => (
            <TableRow>
              <Mobile>
                <TableCell>
                  <Typography>
                    {estimate.invoice.Metal} ({estimate.invoice.Weight})
                  </Typography>
                </TableCell>
              </Mobile>
              <Default>
                <TableCell>
                  <Typography>{estimate.invoice.Weight}</Typography>
                </TableCell>
                <TableCell>
                  <Typography>{estimate.invoice.Metal}</Typography>
                </TableCell>
              </Default>
              <TableCell>
                <Typography>
                  {formatting["price2"](estimate.invoice.WePay)}
                </Typography>
              </TableCell>
              <TableCell>
                <ClearIcon
                  onClick={() => removeEstimate(estimate.id)}
                  className="pointer"
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
}
